import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { catchError, Observable, switchMap } from 'rxjs';
import { TokenAuthService } from './token-auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  ContributorCommissionRatePlanApprovalDto,
  ContributorCommissionRatePlanUpdateDto,
} from '../components/configuration/models/commission-rate-tier.models';

@Injectable({
  providedIn: 'root'
})
export class ContributorCommissionRatePlanService {
  private readonly contributor_rate_plan_Url = `${environment.base_URL}${environment.contributorCommissionRatePlan_URL}`;
  constructor(public tokenAuthService: TokenAuthService,
    private httpClient: HttpClient,
  ) { }

 
  // Method to fetch template data

  getTemplateData(): Observable<any> {
    const url = `${this.contributor_rate_plan_Url}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.get<any[]>(url, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }
  
  submitCommissionRatePlanForApproval(commissionRatePlanDto: ContributorCommissionRatePlanApprovalDto): Observable<any> {
    const url = `${this.contributor_rate_plan_Url}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.post<any[]>(url, commissionRatePlanDto, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  getContributorCommissionPendingApprovals(contributorId: any): Observable<any> {
    const url = `${this.contributor_rate_plan_Url}/contributor/${contributorId}/pending-approvals`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.get<any[]>(url, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

    getContributorCommissionById(contributorId: any,ratePlanId:any): Observable<any> {
    const url = `${this.contributor_rate_plan_Url}/contributor/${contributorId}/rate-plan/${ratePlanId} `;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.get<any[]>(url, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

      viewContributorCommissionPendingApprovals(contributorId: any,planApprovalId:any): Observable<any> {
    const url = `${this.contributor_rate_plan_Url}/contributor/${contributorId}/pending-approvals/${planApprovalId} `;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.get<any[]>(url, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  approvePendingCommissionRatePlan(id: any): Observable<any> {
    const url = `${this.contributor_rate_plan_Url}/approve/${id}`;
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
        return this.httpClient.post<any[]>(url, {}, { headers });
      }),
      catchError((error) => { throw error; })
    );
  }

  bulkApprove(ids: number[]): Observable<{ succeeded: number[]; failed: Record<string, string> }> {
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
        return this.httpClient.post<{ succeeded: number[]; failed: Record<string, string> }>(
          `${this.contributor_rate_plan_Url}/approve`, ids, { headers }
        );
      }),
      catchError((error) => { throw error; })
    );
  }

    rejectPendingCommissionRatePlan(id: any): Observable<any> {
    const url = `${this.contributor_rate_plan_Url}/reject/${id}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.post<any[]>(url, {}, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  getCommissionRatePlanByContributorId(contributorId: any): Observable<any> {
    const url = `${this.contributor_rate_plan_Url}/contributor/${contributorId}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.get<any[]>(url, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  updateContribuitorCommissionRatePlan(id:any,commissionRatePlanDto: ContributorCommissionRatePlanUpdateDto): Observable<any> {
    const url = `${this.contributor_rate_plan_Url}/${id}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.put<any[]>(url, commissionRatePlanDto, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  deleteCommissionRatePlan(id: any): Observable<any> {
    const url = `${this.contributor_rate_plan_Url}/${id}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.delete<any[]>(url, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

    getPendingApprovals(): Observable<any> {
    const url = `${this.contributor_rate_plan_Url}/pending-approvals`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.get<any[]>(url, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }
}